/*
  eslint
  no-param-reassign: ["error", { "props": false }]
  no-console: "off"
*/
import _ from 'lodash';
import jwtDecode from 'jwt-decode';
import { isValidToken } from '../utils';

const AuthStoreModule = {
  namespaced: true,
  state: {
    error: null,
    accessToken: localStorage.getItem('access_token') || null,
    idToken: localStorage.getItem('id_token') || null,
    expiresAt: localStorage.getItem('expires_at') || null,
  },
  getters: {
    isLoggedIn(state) {
      if (state.idToken !== null) {
        return true;
      }
      return false;
    },
    idToken(state) {
      return state.idToken;
    },
    identity(state) {
      if (state.idToken !== null) {
        return jwtDecode(state.idToken);
      }
      return null;
    },
  },
  mutations: {
    SET_SESSION(state, payload) {
      state.user = payload.session;
      state.idToken = payload.session.idToken;
      state.accessToken = payload.session.accessToken;
      state.expiresAt = payload.session.expiresIn * 1000 + new Date().getTime();

      localStorage.setItem('access_token', state.accessToken);
      localStorage.setItem('id_token', state.idToken);
      localStorage.setItem('expires_at', state.expiresAt);
    },
    LOGOUT(state) {
      state.accessToken = null;
      state.idToken = null;
      state.expiresAt = null;

      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('expires_at');
    },
    SET_ERROR_MESSAGE(state, payload) {
      state.error = payload;
    },
    SET_SESSION_NULL(state) {
      state.user = null;
      state.idToken = null;
      state.accessToken = null;
      state.expiresAt = null;
    },
  },
  actions: {
    async handleQueryError({ commit }, err) {
      if (_.has(err, 'message')) {
        commit('SET_ERROR_MESSAGE', err);
      }
    },
    async logoutUser({ commit }) {
      // eslint-disable-next-line
      this._vm.$auth.logout({
        returnTo: window.location.origin,
        clientID: process.env.VUE_APP_AUTH0_CLIENT_ID,
      });
      commit('LOGOUT');
    },
    async initializeUser() {
      return null;
    },
    async getOrRefreshToken({ commit, state }) {
      if (state.idToken !== null && isValidToken(state.idToken)) {
        return state.idToken;
      }
      const session = await new Promise((resolve, reject) => {
        // Setting a timeout of 8 seconds.
        // If there is an error in this call it is not immediately returned.
        // eslint-disable-next-line
        this._vm.$auth.checkSession({ timeout: 8000 }, (err, authResult) => {
          if (err) {
            reject(err);
          }
          resolve(authResult);
        });
      }).catch((err) => {
        // eslint-disable-next-line
        this._vm.$log.debug(`checkSession Error ${err}`);
        commit('SET_SESSION_NULL', { session });
      });
      if (session) {
        commit('SET_SESSION', { session });
      }
      return state.idToken;
    },
    async handleAuthentication({ commit }) {
      const session = await new Promise((resolve, reject) => {
        // eslint-disable-next-line
        this._vm.$auth.parseHash((err, authResult) => {
          if (err) {
            if (Object.prototype.hasOwnProperty.call(err, 'errorDescription')) {
              commit('SET_ERROR_MESSAGE', err.errorDescription);
            } else {
              commit('SET_ERROR_MESSAGE', 'Unknown Error');
            }
            reject(err);
          }
          resolve(authResult);
        });
      });
      commit('SET_SESSION', { session });
    },
  },
};

export default AuthStoreModule;
